<app-modal-dialog 
[show]="showModal" 
size="auto" 
position="top"
(closed)="closedCreateCoa()"
#modal >
    <div class="modal-header" modal-header>
        <h1>Crear COA</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>
    <div class="modal-body" modal-body>
        <div class="row mb-4">
            <div class="col-md-4 form-group mb-4">
                <label for="provider-note" class="form-label">Cliente/Proveedor<span
                    class="required">*</span></label>
                <div class="input-group">
                    <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.provider"
                        [placeholder]="'Ingresa un Proveedor'" [filterElements]="filterProviders"
                        [typeElements]="'provider-note'" (inputMethod)="writeProvider($event.event)"
                        (changeStatus)="checkProvider($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                        ></app-input-autocomplete>
                </div>
            </div>

            <div class="col-md-4 form-group mb-4">
                <label for="product-order" class="form-label">Producto<span>*</span></label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un producto'"
                        [filterElements]="filterProducts"
                        [typeElements]="'product-order'"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>

            <div class="col-md-4 form-group mb-4">
                <label for="entryDate" class="form-label">Fecha<span>*</span></label>
                <input
                type="date"
                [ngModel]="coaData.date | date: 'yyyy-MM-dd'"
                (ngModelChange)="coaData.date = $event"
                name="entryDate"
                id="entryDate"
                class="form-control"
                />
            </div>

            

            <!-- <div class="col-sm-12 form-group mb-4" *ngIf="inputs.product.verified">
                <label for="parameter" class="form-label">Parametro</label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.parameter"
                        [placeholder]="'Ingresa un parametro'"
                        [filterElements]="filterCoasParameter"
                        [typeElements]="'parameter'"
                        (inputMethod)="writeParameter($event.event)"
                        (changeStatus)="checkParameter($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.parameter
                        "
                    ></app-input-autocomplete>
                </div>
            </div> -->
            

            <div class="row" *ngIf="inputs.product.verified">
                <!-- <div class="col"> -->
                    <div class="table-responsive table-bordered">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Parámetro</th>
                                    <th class="text-right ">Método</th>
                                    <th class="text-right">Valor</th>
                                    <th>Comentario</th>
                                    <th class="td-center ">Unidad / Ítem</th>
                                    <th class="td-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor=" let item of listParams; let i = index">
                                    <td>
                                        {{ item.parameter.parameter }}
                                    </td>
                                    <td class="td-center">
                                        {{ item.parameter.method }}
                                    </td>
                                    <td class="text-right ">
                                        <input
                                        type="number"
                                        [ngModel]="item.value"
                                        (ngModelChange)="item.value = $event"
                                        class="form-control"
                                        />
                                    </td>
                                    <td class="text-right">
                                        <input
                                        type="text"
                                        [ngModel]="item.comment"
                                        (ngModelChange)="item.comment = $event"
                                        class="form-control"
                                        />
                                    </td>
                                    <td class="td-center ">
                                        {{ item.parameter.units }}
                                    </td>
                                    <td class="td-center">
                                        <span class="text-danger a-hover" 
                                        tooltip="Eliminar"
                                        (click)="removeParam(i)">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                <!-- </div> -->
            </div>
            <div class="row mt-4">
            <div class="d-flex justify-center">
                <button class="btn btn-success" (click)="createCoa()"
                    [disabled]="loading || !inputs.provider.verified || !inputs.product.verified || !coaData.date || listParams.length == 0 || currentProvider==null || currentProduct==null || verifyParameters">
                    <ng-container *ngIf="!loading">
                        <i class="fa fa-floppy-disk"></i>
                    </ng-container>
                    <ng-container *ngIf="loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"></span>
                    </ng-container> GUARDAR
                </button>
            </div>
	    </div>
        </div>
    </div>
</app-modal-dialog>